(function () {
  var FAVORITE_CHANGE_EVENT = 'product:favorite-change';
  var storageKey = 'favorite_products';

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  function setFavorite(handle, isFavorite) {
    var favorites = getFavorites();
    var index = favorites.indexOf(handle);

    if (isFavorite && index === -1) {
      favorites.push(handle);
    } else if (!isFavorite && index !== -1) {
      favorites.splice(index, 1);
    }

    localStorage.setItem(storageKey, JSON.stringify(favorites));
    document.dispatchEvent(
      new CustomEvent(FAVORITE_CHANGE_EVENT, { detail: { handle: handle, isFavorite: isFavorite } })
    );
  }

  function bindFavoriteButton(btn) {
    btn.setAttribute('data-favorite-bound', 'true');

    var productHandle = btn.getAttribute('data-product-handle');

    function updateState(isFavorite) {
      btn.classList.toggle('is-favorited', isFavorite);
      btn.setAttribute('aria-pressed', isFavorite);
      var label = btn.querySelector('.product-favorite-button__label');
      if (label) {
        label.textContent = isFavorite
          ? btn.getAttribute('data-label-remove')
          : btn.getAttribute('data-label-add');
      }
    }

    updateState(getFavorites().indexOf(productHandle) !== -1);

    btn.addEventListener('click', function () {
      setFavorite(productHandle, !btn.classList.contains('is-favorited'));
    });

    document.addEventListener(FAVORITE_CHANGE_EVENT, function (event) {
      if (event.detail.handle === productHandle) updateState(event.detail.isFavorite);
    });
  }

  document.querySelectorAll('[data-product-favorite]:not([data-favorite-bound])').forEach(bindFavoriteButton);

  window.ProductFavorites = {
    event: FAVORITE_CHANGE_EVENT,
    get: getFavorites,
    set: setFavorite,
  };
})();
